import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { PresenceCallDetailsHubService } from 'src/app/signalr/call-details-hub/presence-call-details-hub.service';
import { PresenceContactRegisterComponent } from './containers/presence-contact-register.component';
import { PresenceContactRegisterEffects } from './state/presence-contact-register.effects';
import {
   presenceContactRegisterFeatureKey,
   presenceContactRegisterReducer,
} from './state/presence-contact-register.reducer';
import { PresenceContactRegisterViewComponent } from './views/presence-contact-register-view.component';

@NgModule({
   declarations: [PresenceContactRegisterComponent, PresenceContactRegisterViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      ReactiveFormsModule,
      RouterModule,
      MatMenuModule,
      RegisterModule,
      ScrollingModule,
      EffectsModule.forFeature([PresenceContactRegisterEffects]),
      StoreModule.forFeature(presenceContactRegisterFeatureKey, presenceContactRegisterReducer),
   ],
   providers: [PresenceCallDetailsHubService],
})
export class PresenceContactRegisterModule {}
